module.exports = __webpack_public_path__ + "static/media/14.73d88c6e.jpg";